var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62631 6.392L2.75987 6.24174C3.24938 5.72986 3.97863 5.47375 4.94695 5.47375H21.5421C22.4546 5.47375 23.1558 5.69647 23.6457 6.14157L23.6624 6.15826C23.7625 6.24742 23.863 6.35293 23.9629 6.47547C23.9629 6.48683 23.9686 6.49784 23.9796 6.50886L23.9963 6.52556C24.3639 6.98201 24.5472 7.62745 24.5472 8.46221V17.9117C24.5362 19.9152 23.5345 20.9169 21.5421 20.9169H4.94695C2.95454 20.9059 1.9585 19.9042 1.9585 17.9117V8.46221C1.9585 7.56067 2.18121 6.87048 2.62631 6.392ZM22.093 7.10989C21.9261 7.06548 21.7424 7.04845 21.5424 7.05981H4.94695C4.82441 7.04879 4.70754 7.05413 4.59635 7.0765L13.1944 15.7914L22.093 7.10989ZM3.54455 8.27856C3.53353 8.33433 3.53353 8.39543 3.54455 8.46221V17.9117C3.54455 18.858 4.01202 19.3308 4.94695 19.3308H21.5421C22.488 19.3308 22.9612 18.858 22.9612 17.9117V8.47891L13.7454 17.4777C13.5784 17.6336 13.3894 17.7114 13.1781 17.7114C12.9554 17.7004 12.766 17.6223 12.6104 17.4777L3.54455 8.27856Z",
    fill: "#A37C4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62646 6.39171C2.64884 6.35832 2.67655 6.32493 2.70994 6.29154C2.72129 6.26917 2.73765 6.25247 2.76003 6.24146L2.62646 6.39171Z",
    fill: "#A37C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7753abc36816df4b0712f198dc5c50ef.svg";
export { ForwardRef as ReactComponent };